import { useState } from "react";

export default function Slide9() {
  const [copied, setCopied] = useState("");
  const email = "sigmasolutions334@gmail.com";
  const phone = "9945948081";

  const copyToClipboard = async (value, key) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied(""), 1600);
    } catch (e) {
      // ignore clipboard errors
    }
  };

  return (
    <section className="w-full max-w-[1400px] mx-auto relative z-10 px-3 sm:px-4 md:px-6 py-8 sm:py-12 md:py-16 lg:py-20">
      <div className="absolute -left-24 -top-10 w-72 h-72 rounded-full blur-3xl bg-gradient-to-br from-white/12 to-white/6 pointer-events-none opacity-60 hidden md:block" />

      <div className="bg-gradient-to-br from-white/6 to-white/3 backdrop-blur-md border border-white/8 rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 lg:p-8 xl:p-12 shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 sm:gap-6 md:gap-8">
          {/* Left: Textual content (expanded) */}
          <div className="flex-1 text-left">
            <h1
              className="text-white font-extrabold mb-2 sm:mb-3 title-gradient"
              style={{ fontSize: "clamp(28px, 6.6vw, 74px)", lineHeight: 1.02 }}
            >
              Launch bold. Delight users. Win markets.
            </h1>

            <p
              className="text-white/85 mb-2 sm:mb-3 md:mb-4 lg:mb-6"
              style={{ fontSize: "clamp(14px, 2.2vw, 20px)" }}
            >
              We turn bold ideas into polished products — fast, secure, and
              irresistibly usable.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 md:gap-4 max-w-2xl mb-2 sm:mb-3 md:mb-4 lg:mb-6">
              <div className="flex flex-col gap-1.5 sm:gap-2 p-2 sm:p-3 md:p-4 bg-white/8 bg-clip-padding backdrop-blur-sm border border-white/20 rounded-lg shadow-xl">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-md bg-white/12 flex items-center justify-center text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 12l5 5L20 7"
                      />
                    </svg>
                  </div>
                  <div className="font-semibold text-white text-sm sm:text-base md:text-base">
                    Product strategy that converts
                  </div>
                </div>
                <div className="text-white/70 text-xs sm:text-sm md:text-sm mt-0.5 sm:mt-1">
                  User-first roadmaps that boost activation, reduce churn, and
                  drive revenue growth.
                </div>
              </div>

              <div className="flex flex-col gap-1.5 sm:gap-2 p-2 sm:p-3 md:p-4 bg-white/8 bg-clip-padding backdrop-blur-sm border border-white/20 rounded-lg shadow-xl">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-md bg-white/12 flex items-center justify-center text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 2v10l3-3 3 3V2"
                      />
                    </svg>
                  </div>
                  <div className="font-semibold text-white text-sm sm:text-base md:text-base">
                    MVPs shipped in weeks
                  </div>
                </div>
                <div className="text-white/70 text-xs sm:text-sm md:text-sm mt-0.5 sm:mt-1">
                  Tightly scoped launches with rapid validation and measurable
                  KPIs.
                </div>
              </div>

              <div className="flex flex-col gap-1.5 sm:gap-2 p-2 sm:p-3 md:p-4 bg-white/8 bg-clip-padding backdrop-blur-sm border border-white/20 rounded-lg shadow-xl">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-md bg-white/12 flex items-center justify-center text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 11c2.21 0 4-1.79 4-4V5c0-1.1-.9-2-2-2H10C8.9 3 8 3.9 8 5v2c0 2.21 1.79 4 4 4zM6 20v-3a4 4 0 014-4h4a4 4 0 014 4v3"
                      />
                    </svg>
                  </div>
                  <div className="font-semibold text-white text-sm sm:text-base md:text-base">
                    Secure, scalable systems
                  </div>
                </div>
                <div className="text-white/70 text-xs sm:text-sm md:text-sm mt-0.5 sm:mt-1">
                  Modern infra, CI/CD, and observability for resilient growth.
                </div>
              </div>
            </div>

            <div className="mb-2 sm:mb-3 md:mb-4 lg:mb-6">
              <a
                href={`mailto:${email}?subject=Intro%20from%20Pitch%20Deck`}
                className="inline-flex items-center gap-2 sm:gap-3 px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 md:py-2.5 lg:py-3 bg-white text-slate-900 font-semibold text-sm sm:text-base rounded-lg shadow-lg hover:bg-slate-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 sm:w-5 sm:h-5 text-slate-700"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8"
                  />
                </svg>
                Schedule a quick intro
              </a>
            </div>

            <p className="text-white/70 italic text-xs sm:text-sm md:text-sm">
              Prefer Slack, Google Meet, or a coffee? We'll make it happen.
            </p>
          </div>

          {/* Right: QR + Contacts (larger, centered) */}
          <div className="w-full md:w-72 flex-shrink-0">
            <div className="bg-white/6 p-3 sm:p-4 md:p-6 rounded-xl sm:rounded-2xl flex flex-col items-start text-left border border-white/12 shadow-xl">
              <div className="self-center text-xs sm:text-sm md:text-sm text-white/80 mb-1 sm:mb-2">
                Scan to visit
              </div>
              <img
                src="/qr.png"
                alt="Scan to visit"
                className="self-center w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 lg:w-44 lg:h-44 object-contain rounded-md bg-white/4 p-1.5 sm:p-2"
              />

              <div className="text-white/90 mt-2 sm:mt-3 md:mt-4 text-xs sm:text-sm md:text-sm w-full">
                <div className="font-semibold text-white text-base sm:text-lg">Get in touch</div>

                <div className="mt-2 sm:mt-3 space-y-2 sm:space-y-3">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm sm:text-base text-white">Email</div>
                      <div className="text-xs sm:text-sm text-white/70">{email}</div>
                    </div>
                    <button
                      onClick={() => copyToClipboard(email, "email")}
                      aria-label="Copy email"
                      className="p-1.5 sm:p-2 bg-white/10 rounded text-white hover:bg-white/16"
                    >
                      {copied === "email" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 sm:w-4 sm:h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 sm:w-4 sm:h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8 7h8v10H8z"
                          />
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M16 7V5a1 1 0 00-1-1H6a1 1 0 00-1 1v10"
                          />
                        </svg>
                      )}
                    </button>
                  </div>

                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm sm:text-base text-white">Phone</div>
                      <div className="text-xs sm:text-sm text-white/70">{phone}</div>
                    </div>
                    <button
                      onClick={() => copyToClipboard(phone, "phone")}
                      aria-label="Copy phone"
                      className="p-1.5 sm:p-2 bg-white/10 rounded text-white hover:bg-white/16"
                    >
                      {copied === "phone" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 sm:w-4 sm:h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3 sm:w-4 sm:h-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8 7h8v10H8z"
                          />
                          <path
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M16 7V5a1 1 0 00-1-1H6a1 1 0 00-1 1v10"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
